import { Context } from '../..';
import * as base from '../base';
import { NotificationPriority, NotificationType } from '../../../notifications/notifications.models';

const CONTROLLER = 'agents';

export interface AgentTypeDto {
  name: string;
  displayName: string;
  description: string;
}

interface PropertyDescriptionDto {
  propertyName: string;
  description: string;
}

interface UserPromptTemplateDto {
  intro: string;
  outro: string;
}

interface PropertyLabelDto {
  propertyName: string;
  label: string;
}

export interface AgentDto {
  agentTypeName: string;
  displayName: string;
  description: string;
  systemPromptOverride: string;
  propertyDescriptionOverrides: PropertyDescriptionDto[];
  propertyLabelOverrides: PropertyLabelDto[];
  userPromptTemplateOverride: UserPromptTemplateDto;
  contextIds: string[];
}

export async function getAgentTypes(): Promise<AgentTypeDto[] | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, 'types') };
  const response: base.IResponse<AgentTypeDto[]> = await base.requestWithRetries(request);
  return response.data;
}

export async function getAgent(context: Context, payload: { companySlug: string; agentTypeName: string }): Promise<AgentDto | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload.companySlug, payload.agentTypeName) };
  const response: base.IResponse<AgentDto> = await base.requestWithRetries(request);
  return response.data;
}

export async function upsertAgent(context: Context, payload: { companySlug: string; agentTypeName: string; agent: AgentDto }): Promise<string | undefined> {
  const request: base.IRequest = {
    url: base.aiURL(CONTROLLER, payload.companySlug, payload.agentTypeName),
    method: 'PUT',
    body: JSON.stringify(payload.agent),
  };
  const response: base.IResponse<string> = await base.requestWithRetries(request);

  context.actions.addNotification({
    id: crypto.randomUUID(),
    title: 'Agent updated',
    message: `${payload.agent.displayName} has been successfully updated`,
    priority: NotificationPriority.Toast,
    type: NotificationType.Success,
    active: true,
  });

  return response.data;
}

export async function deleteAgent(context: Context, payload: { companySlug: string; agentTypeName: string }): Promise<void> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload.companySlug, payload.agentTypeName), method: 'DELETE' };
  await base.requestWithRetries(request);
}
